import { PayType, SitePayTypeSetting } from '@/domain/models/Order';
import { OrderMethod } from '@/domain/models/Order/orderMethod';
import { errorHandler } from '@/lib/ErrorHandler';
import { getClient } from '@/lib/restClient';
import {
  CustomField,
  GMOShopPaymentMethodConfig,
} from '@/pages/camel-order/sites/service';
import { SiteService } from '@/services/Site/SiteService';

/**
 *  @note 0 が非公開, 1が公開, 2が限定公開, 3がメンテナンス中
 * **/
export type SiteStatus = 0 | 1 | 2 | 3;
export type DisplaySpecialInstruction = 0 | 1;
export type IsAuthAvailable = 0 | 1;

export const TAX_ROUND_TYPE = {
  ROUND_UP: 'ROUND_UP',
  ROUND_DOWN: 'ROUND_DOWN',
  ROUND_OFF: 'ROUND_OFF',
} as const;

export type TaxRoundType = keyof typeof TAX_ROUND_TYPE;
export type CamelOrderPayType = Exclude<PayType, 'CASH' | ''>;

export type SiteListResponse = {
  id: string;
  url: string;
  title: string;
  description: string;
  logo_url: string;
  favicon_url: string | null;
  primary_color: string;
  faq_url: string;
  inquiry_url: string;
  term_url: string;
  sctl_url: string;
  privacy_url: string;
  status: SiteStatus;
  password: string;
  tax_round_type: TaxRoundType;
  pay_type_settings: SitePayTypeSetting[];
  order_methods: OrderMethod[];
  gmo_setting_completed: boolean;
  gmo_shop_payment_method_config: GMOShopPaymentMethodConfig;
  google_tag_ids: string[];
  display_special_instruction: boolean;
  is_auth_available: boolean;
  notification_text: string;
  delivery_minimum_amount: number;
  delivery_cart_item_limit: number | null;
  use_three_d_secure2: boolean;
  is_three_d_secure2_setting_available: boolean;
  site_banners: {
    id: string;
    image_url: string;
    link_url: string | null;
    sort_index: number;
  }[];
  gmo_shop: {
    name: string;
    name_kana: string;
    name_alphabet: string;
    name_short: string;
    contact_name: string;
    contact_email: string;
    contact_phone: string;
    contact_opening_hours: string;
    contact_closing_hours: string;
  } | null;
  custom_order_method_text: {
    takeout: {
      is_custom: boolean;
      text: string | null;
      button_text: string | null;
    };
    eat_in: {
      is_custom: boolean;
      text: string | null;
      button_text: string | null;
    };
    delivery: {
      is_custom: boolean;
      text: string | null;
      button_text: string | null;
    };
  };
  custom_fields: CustomField[];
};

export const useSiteList = async (): Promise<SiteListResponse[]> => {
  const siteService = new SiteService(getClient());
  try {
    const res = await siteService.list();
    return res;
  } catch (error) {
    // @ts-ignore TS2322
    return errorHandler({ error });
  }
};
